"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onValueChange = exports.onBlurred = exports.getState = exports.getLabelAttr = exports.getHelperText = exports.getAttributes = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _colors = require("../tokens/colors");
var _sizes = require("../tokens/sizes");
var _get2 = _interopRequireDefault(require("lodash-es/get"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getPadding = function getPadding(top, right, bottom, left) {
  return "".concat(top, "rem ").concat(right, "rem ").concat(bottom, "rem ").concat(left, "rem");
};
var getInputAttributes = function getInputAttributes(props) {
  // Get the styles for the button's selected size.
  var focusedState = ["focused", "error", "hideLabel", "error_focused", "error_hideLabel"].includes(props.state);
  var colorStyle = _colors.input[props.state];
  if (props.borderColor) {
    if (["hideLabel", "focused"].includes(props.state)) {
      colorStyle.borderColor = props.borderColor;
    }
    if (["focused"].includes(props.state)) {
      colorStyle.placeholder = props.borderColor;
    }
  }
  var vPadding = _sizes.inputPadding.vPadding,
    hzPadding = _sizes.inputPadding.hzPadding;
  var pright = props.icon || props.rightLoader ? hzPadding + 2.3 : hzPadding;
  var pleft = props.leftIcon || props.leftLoader ? hzPadding + 2.3 : hzPadding;
  var focusedPadding = getPadding(vPadding - 0.05, pright - 0.05, vPadding - 0.05, pleft - 0.05);
  var padding = focusedState ? focusedPadding : getPadding(vPadding, pright, vPadding, pleft);
  var width = props.fullWidth ? "100%" : props.width;
  return _objectSpread(_objectSpread(_objectSpread({}, colorStyle), _sizes.input), {}, {
    width: width,
    padding: padding
  });
};
var getLabelAttributes = function getLabelAttributes(props) {
  if (props.state === "disabled") {
    return _objectSpread(_objectSpread({}, _sizes.inputPhFocused), {}, {
      labelBackground: _colors.input.disabled.background
    });
  }
  if ((props.state === "hideLabel" || props.hideLabel) && props.value) {
    return _objectSpread({}, _sizes.inputNoLabel);
  }
  if (props.showLbl && props.hideLabel && props.leftIcon) {
    return _objectSpread(_objectSpread({}, _sizes.inputPhLeftIcon), {}, {
      background: _colors.input["default"].background
    });
  }
  if (props.showLbl && props.hideLabel) {
    return _objectSpread(_objectSpread({}, _sizes.inputPhDefault), {}, {
      background: _colors.input["default"].background
    });
  }
  if (props.showLbl) {
    return _objectSpread(_objectSpread({}, _sizes.inputPhFocused), {}, {
      background: _colors.input["default"].background
    });
  }
  if (props.leftIcon || props.leftLoader) {
    return _objectSpread(_objectSpread({}, _sizes.inputPhLeftIcon), {}, {
      background: _colors.input["default"].background
    });
  }
  return _objectSpread(_objectSpread({}, _sizes.inputPhDefault), {}, {
    background: _colors.input["default"].background
  });
};
var getHelperText = exports.getHelperText = function getHelperText(helperText, errorMsg) {
  if (errorMsg) {
    return errorMsg;
  }
  if (helperText) {
    return helperText;
  }
  return "";
};
var getAttributes = exports.getAttributes = function getAttributes(key) {
  return function (props) {
    return getInputAttributes(props)[key];
  };
};
var getLabelAttr = exports.getLabelAttr = function getLabelAttr(key) {
  return function (props) {
    return getLabelAttributes(props)[key];
  };
};
var getState = exports.getState = function getState(props, focused) {
  if (props.disabled) {
    return "disabled";
  }
  if (props.errorMsg && focused && props.hideLabel) {
    return "error_hideLabel";
  }
  if (focused && props.hideLabel) {
    return "hideLabel";
  }
  if (props.errorMsg && (focused || props.value)) {
    return "error_focused";
  }
  if (props.errorMsg) {
    return "error";
  }
  if (focused) {
    return "focused";
  }
  return "default";
};
var onValueChange = exports.onValueChange = function onValueChange(props) {
  return function (e) {
    var newValue = (0, _get2["default"])(e, "target.value");
    props.onChange(newValue, e);
  };
};
var onBlurred = exports.onBlurred = function onBlurred(props, onFocusToggle) {
  return function (e) {
    var newValue = (0, _get2["default"])(e, "target.value");
    onFocusToggle();
    props.onBlur(newValue, e);
  };
};